import type { TourDefinition } from '../tours.types';


export const CASE1_FIRMA_ASICIACION_GRUPOS_TOUR: TourDefinition = {
  id: 'case1_firma_asociacion_grupos_help',
  //route: '/firmas/firma',
  remember: true,
  steps: [
    {
      element: '[data-tour="case-firma-root"]',
      popover: {
        title: 'Asociación de firmantes',
        description:
          'En este paso defines los participantes de este proceso de firma; debes seleccionar un grupo donde a cada uno de los participantes se le solicitará su firma. Posterior a esto, debes seleccionar 1 o más certificados individuales; estos serán los que firmarán de manera masiva sobre los documentos firmados por el grupo.',
        side: 'bottom',
        align: 'center',
      },
    },

    {
      element: '[data-tour="btn-agregar-grupos"]',
      popover: {
        title: 'Agregar grupo',
        description:
          'Aquí puedes agregar el grupo al que deseas solicitar su firma sobre el documento que has adjuntado',
        side: 'bottom',
        align: 'start',
      },
    },

    {
      element: '[data-tour="tab-firmantes"]',
      popover: {
        title: 'Pestaña firmantes',
        description:
          'Una vez agregues un grupo o un certificado individual, aquí podrás ver el grupo agregado y los certificados individuales a manera de resumen.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="tab-certificados"]',
      popover: {
        title: 'Firma grupal',
        description:
          'Aquí podrás ver el detalle de todos los certificados agregados, tanto los individuales como los que son parte del grupo seleccionado.',
        side: 'right',
        align: 'center',
      },
    },    
    {
      element: '[data-tour="firma-next"]',
      popover: {
        title: 'Continuar',
        description:
          'Cuando hayas definido los participantes, tanto el grupo como los certificados individuales, da clic en siguiente para pasar a la selección de áreas de firma.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
